import { useGetUsers } from './use-get-users';

export const useUsersCurrentPage = (): number => {
  const usersQuery = useGetUsers();

  return usersQuery?.data?.pagination.currentPage
    ? usersQuery.data.pagination.currentPage - 1
    : 0;
};
